import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import initialApiService from 'services/initialApiService';

import { slices } from './slices';

export const store = configureStore({
  reducer: {
    [initialApiService.reducerPath]: initialApiService.reducer,
    ...slices,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(initialApiService.middleware);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
